const commonPlugin = {
    install(Vue, optiuons) {
        Vue.prototype.$DataValid = function (payload) {
            return payload == null || payload.length == 0 ? false : payload
        }

        Vue.prototype.$movePrev = function () {
            this.$router.go(-1)
        }

        Vue.prototype.$moveLogin = function () {
            this.$router.push('/login')
        }

        Vue.prototype.$moveMain = function () {

            this.$router.push('/home')
        }
    }
}

export default commonPlugin